import { render } from "./CreateVehicleForm.vue?vue&type=template&id=4b593b86&scoped=true"
import script from "./CreateVehicleForm.vue?vue&type=script&lang=js"
export * from "./CreateVehicleForm.vue?vue&type=script&lang=js"

import "./CreateVehicleForm.vue?vue&type=style&index=0&id=4b593b86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b593b86"]])

export default __exports__